<template>
  <div class="side-menu" style="text-align: left">
    <ul>
      <template v-for="(menu,key) in menus">

        <li :class="'mli fli li-'+(zhoren=='zh'||zhoren=='zh-tw'?'zh':'en')+' '+$t('tli-b')" :key="menu.name"
          @click="handleClick(menu)" v-if="!!!menu.hidden">
          <!-- <router-link
            class="sub-menu-item"
            v-if="menu.name == '/index/wantOrder'"
            target="_blank"
            :to="'/index/wantOrder'"
          >
            <i
              class="sub-menu-icon"
              style="font-size: 18px"
              :class="menu.icon"
            ></i>
            <span class="sub-menu">
              {{ $t(menu.translate) }}
            </span>
            <span class="sub-menu-text">
              {{ $t('menus_XD') }}
            </span>
          </router-link>
          <router-link class="sub-menu-item" v-else :to="menu.name">
            <div class="">
              <i
                class="sub-menu-icon"
                style="font-size: 18px"
                :class="menu.icon"
             ></i>
           <span class="sub-menu">
              {{ $t(menu.translate) }}
              </span>
            </div>
          </router-link> -->
          <a v-if="menu.children.length>0">
            <div class="">
              <i class="sub-menu-icon" style="font-size: 18px" :class="menu.icon"></i>
              <span class="sub-menu">
                {{ $t(menu.translate) }}
              </span>
            </div>
          </a>
          <router-link class="sub-menu-item" v-else :to="menu.name">
            <div class="">
              <i class="sub-menu-icon" style="font-size: 18px" :class="menu.icon"></i>
              <span class="sub-menu">
                {{ $t(menu.translate) }}
              </span>
            </div>
          </router-link>
        </li>
        <li :class="'tmenu-li mli t-'+(zhoren=='zh'||zhoren=='zh-tw'?'zh':'en')+' '+$t('tli-s')+' cmenu-o-'+key"
          v-if="menu.children.length>0">
          <template v-for="(tmenu,index) in menu.children">

            <div class="tmenu-box" :class="'cmenu-'+key+'-'+index">
              <router-link v-if="tmenu.is_role==undefined||role==2" :target="tmenu.target==undefined?'_self':'_blank'"
                :to="tmenu.name">
                {{ $t(tmenu.translate) }}
              </router-link>
              <a v-else @click="go_role">
                {{ $t(tmenu.translate) }}
              </a>
            </div>


          </template>
        </li>

      </template>
    </ul>
  </div>
</template>

<script>
  import router from "@/router/router.js";
  export default {
    name: "SideMenu",
    inject: ["reload"],
    data: () => ({
      currentPathName: "",
      role: 1,
      zhoren: localStorage.getItem("locale") || "zh",
      // menus: [
      //   { label: "订单管理", name: "order" },
      // ]
    }),
    computed: {

      menus() {
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.role = userInfo.role;
        const { children } = router;
        let route = children;
        // this.role = 2;
        /* let before =
           userInfo.role == 1 ? "/user" : userInfo.role == 2 ? "/insp" : "/user";
         const { children } = router;
         let route = children;
         if (userInfo.role == 1 || userInfo.role == 3) {
           route = route.filter((item, index) => {
             return item.path != "evaluate";
           });
         } else if (userInfo.role == 2) {
           route = route.filter((item, index) => {
             return item.path != "/index/wantOrder" && item.path != "Mysuppliers";
           });
         }
         route.forEach((item) => {
           if (item.label == "订单管理") {
             if (userInfo.role == 2) {
               item.translate = "user_Index_YHGL";
             } else {
               item.translate = "user_Index_DDGL";
             }
           }
         });*/
        // console.log(route, "==route==route===route===route==")
        return route;
        return route.map(
          ({ path, name, icon, label, translate, children, hidden = false }) => ({
            path,
            /*  name,  */
            icon,
            name:
              name != "/index/wantOrder"
                ? before + "/" + name
                : "/index/wantOrder",
            // label: before + '/' +label ? label : name,
            translate,
            children,
            hidden,
          })
        );
      },
    },
    created() {
      this.init();
    },
    methods: {
      go_role() {
        this.$alert('你不是验货员，无此权限，申请验货员资格，请在APP里申请', '提示', {
          confirmButtonText: '关闭',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: `action: ${ action }`
            // });
          }
        });
      },
      init() {
        const { name } = this.$route;
        this.currentPathName = name;
      },
      handleClick({ name }) {
        if (this.currentPathName == name) {
          this.reload();
        }
        this.currentPathName = name;
      },
      // routerClick(){
      //   // this.$router.go(0)
      //   // window.location.reload()
      //   // this.$router.go(0);

      // }
    },
  };
</script>

<style lang="scss" scoped>
  @import "../sass/mixins.scss";

  .sub-menu-item,
  a {
    // background-color: #fff;

    display: flex;

    .sub-menu-icon {
      margin-right: 10px;
    }

  }

  a:hover {
    cursor: pointer;
  }

  /* 小屏幕的样式*/
  @media screen and (max-width: 720px) {
    .sub-menu {
      display: none;
    }

    // .sub-menu-icon {
    //   margin-left: 10px;
    //   margin-right: 10px;
    // }
    .sub-menu-text {
      font-size: 12px;
      line-height: 20px;
      text-align: center;
    }
  }

  /* 大屏幕的样式*/
  @media screen and (min-width: 721px) {

    // .sub-menu {
    //   float: right;
    //   width: 150px;
    // }
    // .sub-menu-icon {
    //   margin-left: 20px;
    //   margin-right: 20px;
    // }
    .sub-menu-text {
      display: none;
    }
  }

  .isActive {
    color: #FF5023 !important;
    position: relative;

    ::after {
      position: absolute;
      /*绝对定位*/
      top: 50%;
      /*Y轴方向偏移自身高度的50%*/
      transform: translatey(-40%);
      /*Y轴方向偏移微调*/
      right: 0;
      /*紧靠容器左边缘*/
      content: '';
      /*伪元素需要有内容才能显示*/
      width: 4px;
      /*伪元素宽度*/
      height: 26px;
      /*伪元素高度*/
      background-color: #FF5023;
      /*伪元素颜色*/
    }
  }

  .side-menu {
    text-align: center;

    li.fli {
      a {
        display: block;
        padding: 13px 45px;
        //color: #6B7C8C;
        color: #ffffff;
      }
    }

    li.active {
      position: relative;
      background-color: $--color-primary;

      a {
        color: #fff;
      }

      &::before {
        position: absolute;
        right: 0;
        top: 50%;
        z-index: 100;
        transform: translateY(-50%);
        @include triangle($direction: left, $size: 10px, $borderColor: #FF5023);
      }
    }
  }

  .tmenu-li {
    display: block;
    padding-left: 78px;
    padding-right: 10px;
    color: #9FADCB;
    font-size: 13px;
    overflow: hidden;
    border-bottom: 1px dashed #41495B;

    .tmenu-box {
      width: 50%;
      float: left;
      padding-bottom: 10px;
    }
  }

  .side-menu {
    padding: 0 10px;
  }

  .li-en a {
    padding: 13px 35px !important;
  }

  .t-en .tmenu-box {
    // width:100%!important;
  }

  .tli-in-do a {
    padding: 13px 25px !important;
  }

  .um_li_bo a {
    padding: 13px 15px !important;
    font-size: 12px !important;
  }

  .um_li_so {
    padding-left: 48px !important;
  }

  /*.um_li_so .tmenu-box{
  width: 50% !important;
}*/
</style>